import React from "react";
import MobileViewLive from "./MobileView/MobileViewLive";

function App() {

  return (

     
      <MobileViewLive />
 

  );
}

export default App;
